import styled from 'styled-components';

export const BubbleContainer = styled.div`
	position: fixed;
	width: 300px;
	height: 300px;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;
